import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Spinner } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks.ts';
import { ihutActions, ihutSelectors } from '../../../../redux/slices/ihut.ts';
import { IhutActivity } from '../../../../api/ihut.ts';
import useSnackbar from '../../../../hooks/useSnackbar.ts';
import { logger } from '../../../../utils/logger.js';
import { AUTO_HIDE_DURATION } from '../../../../constants/common.js';
import { Snackbar } from '@material-ui/core';

const TrackStepContinueButton = () => {
  const { snackbarState, openSnackbar, closeSnackbar } = useSnackbar();
  const { t } = useTranslation('common');
  const activity = useAppSelector(
    ihutSelectors.selectSelectedActivity
  ) as IhutActivity;
  const updateStateLoading = useAppSelector(
    ihutSelectors.selectUpdateStateLoading
  );
  const dispatch = useAppDispatch();

  const handleClick = () => {
    logger.clickStream('track_product_step_continue_button_click', {
      activity: activity.ihutProjectId,
      panelistId: localStorage.getItem('panelistId') || ''
    });
    dispatch(ihutActions.updatePanelistState({ delivery: true }))
      .unwrap()
      .catch((err) => {
        logger.error(
          'Error updating ihut panelist state to testing completed',
          err
        );
        openSnackbar(err?.message || t('somethingWentWrong', { ns: 'common' }));
      });
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarState.open}
        message={snackbarState.message}
        autoHideDuration={AUTO_HIDE_DURATION}
        onClose={closeSnackbar}
      />
      <Button
        variant="primary"
        disabled={
          activity.supportCardStatus !== 'confirmed' || updateStateLoading
        }
        size="small"
        UNSAFE_className={styles.continueBtn}
        onClick={handleClick}
      >
        {updateStateLoading ? <Spinner size="small" /> : t('continue')}
      </Button>
    </>
  );
};

export default TrackStepContinueButton;
